<template>
	<ValidationProvider
		ref="validationProvider"
		v-slot="{ errors, classes }"
		:mode="mode"
		:rules="{ required: required }"
		:vid="vid"
		slim
	>
		<v-select
			v-model="selectValue"
			:class="classes"
			:searchable="searchable"
			:clearable="clearable"
			:reduce="reduce"
			:label="optionLabel"
			v-bind="$attrs"
			@search:blur="onBlur"
		/>
		<div
			v-if="$_showErrors(errors, classes)"
			class="input-message"
		>
			<span data-cy="error-message">{{ errors[0] }}</span>
		</div>
	</ValidationProvider>
</template>

<script>
import { ValidationProvider } from 'vee-validate';

export default {
	name: 'AppSelect',

	components: {
		ValidationProvider,
	},

	inheritAttrs: false,

	props: {
		value: {
			type: [String, Number],
			default: '',
		},
		searchable: {
			type: Boolean,
			default: false,
		},
		clearable: {
			type: Boolean,
			default: false,
		},
		required: {
			type: Boolean,
			default: false,
		},
		vid: {
			type: String,
			default: '',
		},
		mode: {
			type: String,
			default: 'eager',
		},
		optionLabel: {
			type: String,
			default: 'name',
		},
		optionValue: {
			type: String,
			default: 'value',
		},
	},

	data() {
		return {
			selectValue: '',
		};
	},

	watch: {
		value: {
			immediate: true,
			handler(value) {
				this.selectValue = value;
			},
		},
		selectValue(selectValue) {
			this.$emit('input', selectValue);
		},
	},

	methods: {
		reduce(option) {
			if (typeof option === 'object') {
				return this.optionValue ? option[this.optionValue] : option;
			}

			return option;
		},
		onBlur() {
			this.$refs.validationProvider.setFlags({
				untouched: false,
				touched: true,
			});

			this.$refs.validationProvider.validate();
		},
		$_showErrors(errors, classes) {
			const hasErrors = errors.length > 0;

			if (this.mode === 'aggressive-touch') {
				return hasErrors && classes.touched;
			}

			return hasErrors;
		},
	},
};
</script>

<style lang="scss" scoped>
.input-message {
	font-size: $size-7;
	margin: $gap-05;
	color: $color-error;
}
</style>
